import { FaCar, FaPlane, FaTrain, FaTaxi, FaMotorcycle, FaBus, FaEllipsisH, FaBed } from 'react-icons/fa';

// Icon + accent colour per travel expense line type. Shared by the Shuttle form
// (Name select) and the Expense summary table so a "Plane" reads the same in
// both places — keep this the single source of truth when adding a new type.

// Transport types offered by the Shuttle form's Name select.
export const SHUTTLE_META = [
  { value: 'Car rental', icon: FaCar,        color: '#2563eb' },
  { value: 'Plane',      icon: FaPlane,      color: '#0ea5e9' },
  { value: 'Train',      icon: FaTrain,      color: '#7c3aed' },
  { value: 'Taxi',       icon: FaTaxi,       color: '#f59e0b' },
  { value: 'Motocycle',  icon: FaMotorcycle, color: '#ea580c' },
  { value: 'Bus',        icon: FaBus,        color: '#16a34a' },
  { value: 'Other',      icon: FaEllipsisH,  color: '#64748b' },
];

// Hotels are not shuttles, but the Expense summary lists them side by side.
export const HOTEL_META = { value: 'Hotel', icon: FaBed, color: '#db2777' };

const BY_NAME = Object.fromEntries([...SHUTTLE_META, HOTEL_META].map((meta) => [meta.value, meta]));
const FALLBACK = { value: 'Other', icon: FaEllipsisH, color: '#64748b' };

// Expense line `name` is free text from the DB (older rows may hold anything),
// so an unknown value falls back to the neutral "Other" chip instead of
// rendering no icon at all.
export const expenseMetaFor = (name) => BY_NAME[name] || FALLBACK;
